import { configureStore } from "@reduxjs/toolkit";
import { authApi } from "../apis/auth";
import { doctorsApi } from "../apis/doctor";
import { setupListeners } from "@reduxjs/toolkit/query";
import { toastReducer } from "../toast-message/toast";
import { repsApi } from "../apis/reps";
import { productsApi } from "../apis/product";
import userSlice from "../slice/userSlice";
import chatSlice from "../slice/chatSlice";
import token from "../slice/token";
import { appointmentApi } from "../apis/appointments";
import { contentApi } from "../apis/content";
import { notificationsApi } from "../apis/notifications";
import { userActivityApi } from "../apis/userActivity";
import messageMiddleware from "../../utils/messageMiddleware";
import NotificationSlice from '../slice/notificationSlice'
import { notificationMiddleware } from "../../utils/notificationMiddleware";
import { googleCalendarApi } from "../apis/googleCalendars";
import { pipelinePerspectiveApi } from "../apis/pipelinePerspective";
import { pipelineDrugsApi } from "../apis/pipelineDrugs";
import reviewPopupSlice from '../slice/reviewPopupSlice';
import { repConnectionRequestsApi } from "../apis/repConnectionRequests";
import { dashboardApi } from "../apis/dashboard";
import compareReducer from "../slice/compareSlice";
import accountDisabledMiddleware from "../../utils/accountDisabledMiddleware";

export const store = configureStore({
  reducer: {
    toaster: toastReducer,
    userData: userSlice,
    chat: chatSlice,
    notifications: NotificationSlice,
    token: token,
    reviewPopup: reviewPopupSlice,
    compare: compareReducer,
    [authApi.reducerPath]: authApi.reducer,
    [userActivityApi.reducerPath]: userActivityApi.reducer,
    [doctorsApi.reducerPath]: doctorsApi.reducer,
    [repsApi.reducerPath]: repsApi.reducer,
    [productsApi.reducerPath]: productsApi.reducer,
    [appointmentApi.reducerPath]: appointmentApi.reducer,
    [googleCalendarApi.reducerPath]: googleCalendarApi.reducer,
    [contentApi.reducerPath]: contentApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer,
    [pipelinePerspectiveApi.reducerPath]: pipelinePerspectiveApi.reducer,
    [pipelineDrugsApi.reducerPath]: pipelineDrugsApi.reducer,
    [repConnectionRequestsApi.reducerPath]: repConnectionRequestsApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      accountDisabledMiddleware,
      messageMiddleware,
      notificationMiddleware,
      authApi.middleware,
      userActivityApi.middleware,
      doctorsApi.middleware,
      repsApi.middleware,
      productsApi.middleware,
      appointmentApi.middleware,
      googleCalendarApi.middleware,
      contentApi.middleware,
      notificationsApi.middleware,
      pipelinePerspectiveApi.middleware,
      pipelineDrugsApi.middleware,
      repConnectionRequestsApi.middleware,
      dashboardApi.middleware,
    ])
});

export const getUserDataFromStore = () => {
  const state = store.getState();
  return state?.userData?.userData?.user ?? {};
};

setupListeners(store.dispatch);
